import React, { useEffect, useState, useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

// Components
import InputForm from '../../../components/Inputs/formInput/InputForm';
import BtnContent from '../../../components/buttons/BtnContent';
import ImageUploader from '../../../components/Inputs/formInput/InputImageUpload';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import MainLoader from '../../../components/Loaders/MainLoader';
import HomeLayout from '../../../layouts/HomeLayout';
// Thunks
import { createConfigThunk, getConfigThunk, initialStateConfig, updateConfigThunk } from '../../../store/slices/catalogs/config.slice';
import { API_BASE_URL } from '../../../store/constans';
import { formatDateForm } from '../../../utils/funtions';
import { Toast } from '../../../resources/utils';
import HeaderSearch from '../../../components/headers/catalogs/HeaderSearch';
import HeaderSection from '../../../components/headers/catalogs/HeaderSection';

const ConfigurationsForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { configuration_id } = useParams();
  const methods = useForm();
  const isLoading = useSelector(state => state.isLoadingSlice);
  const { register, handleSubmit, setValue, formState: { errors } } = methods;
  const { item, error, message } = useSelector(state => state.configurations)
  const [logo, setLogo] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [background, setBackground] = useState(null);
  const [backgroundFile, setBackgroundFile] = useState(null);

  useEffect(() => {
    if (configuration_id) {
      dispatch(getConfigThunk(configuration_id));
    }
    return () => {
      dispatch(initialStateConfig());
    }
  }, [])

  useEffect(() => {
    if (configuration_id) {
      setLogo(API_BASE_URL + item.logo);
      setBackground(API_BASE_URL + item.background);

      setValue('name', item.name);
      setValue('address', item.address);
      setValue('phone', item.phone);
      setValue('director', item.director);
      setValue('currentPeriodStart', formatDateForm(item?.fecha_inicio_periodo_actual));
      setValue('currentPeriodEnd', formatDateForm(item?.fecha_fin_periodo_actual));
      setValue('nextPeriodStart', formatDateForm(item?.fecha_inicio_periodo_siguiente));
      setValue('nextPeriodEnd', formatDateForm(item?.fecha_fin_periodo_siguiente));
      setValue('supportNumber', item?.numero_soporte);
      setValue('supportFrom', item?.soporte_desde);
      setValue('supportTo', item?.soporte_hasta);
    }
  }, [item, setValue]);

  const removeLogo = () => {
    setLogo(null);
    setLogoFile(null);
  };

  const removeBackground = () => {
    setBackground(null);
    setBackgroundFile(null);
  };

  const onSubmit = useCallback((data) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('address', data.address);
    formData.append('phone', data.phone);
    formData.append('director', data.director);
    formData.append('currentPeriodStart', data.currentPeriodStart);
    formData.append('currentPeriodEnd', data.currentPeriodEnd);
    formData.append('nextPeriodStart', data.nextPeriodStart);
    formData.append('nextPeriodEnd', data.nextPeriodEnd);
    formData.append('supportNumber', data.supportNumber);
    formData.append('supportFrom', data.supportFrom);
    formData.append('supportTo', data.supportTo);

    if (logoFile) formData.append('logo', logoFile);
    if (backgroundFile) formData.append('background', backgroundFile);

    if (configuration_id) {
      dispatch(updateConfigThunk(configuration_id, formData));
    } else {
      dispatch(createConfigThunk(formData));
    }
  }, [item, logoFile, backgroundFile, dispatch]);

  useEffect(() => {
    if (message === "Registro creado correctamente " || message === "Registro actualizado correctamente ") {
      Toast.fire({
        icon: 'success',
        title: message,
      });
    }
  }, [message]);

  return (
    <HomeLayout>
      {isLoading ? (
        <MainLoader />
      ) : (
        <div className='mx-5 my-5 w-full'>
          {error ? <Error state={error} /> : " "}
          <HeaderForm title={t("Configuración general")} />
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="flex gap-4">
                <div className="flex flex-col w-full lg:w-1/2">
                  <InputForm
                    spam
                    label={t("Nombre Institución")}
                    input="input"
                    type="text"
                    cols={1}
                    register={register("name", { required: t("required_information") })}
                    placeholder={t("name")}
                    errors={errors.name && <span className="text-red-500 text-xs">{errors.name.message}</span>}
                  />
                  <InputForm
                    spam
                    label={t("Dirección")}
                    input="input"
                    type="text"
                    cols={1}
                    register={register("address", { required: t("required_information") })}
                    placeholder={t("address")}
                    errors={errors.address && <span className="text-red-500 text-xs">{errors.address.message}</span>}
                  />

                  <InputForm
                    spam
                    label={t("RUC")}
                    input="input"
                    type="text"
                    cols={1}
                    register={register("phone", { required: true })}
                    errors={errors.phone && <span className="text-red-500 text-xs">{errors.phone.message}</span>}
                  />
                  <InputForm
                    spam
                    label={t("Rector/a")}
                    input="input"
                    type="text"
                    cols={1}
                    register={register("director", { required: t("required_information") })}
                    placeholder={t("director")}
                    errors={errors.director && <span className="text-red-500 text-xs">{errors.director.message}</span>}
                  />
                  <div className='flex gap-2 my-3'>
                    <InputForm
                      spam={true}
                      label={t("Periodo actual fecha de inicio")}
                      type="date"
                      input="input"
                      cols={1}
                      register={register("currentPeriodStart", { required: true })}
                      errors={errors.currentPeriodStart && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                    />
                    <InputForm
                      spam={true}
                      label={t("Periodo actual fecha de finalizacion")}
                      type="date"
                      input="input"
                      cols={1}
                      register={register("currentPeriodEnd", { required: true })}
                      errors={errors.currentPeriodEnd && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                    />
                  </div>
                  <div className='flex gap-2 mb-2'>
                    <InputForm
                      spam={true}
                      label={t("Siguiente periodo fecha de inicio")}
                      type="date"
                      input="input"
                      cols={1}
                      register={register("nextPeriodStart", { required: true })}
                      errors={errors.nextPeriodStart && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                    />
                    <InputForm
                      spam={true}
                      label={t("Siguiente periodo fecha de finalizacion")}
                      type="date"
                      input="input"
                      cols={1}
                      register={register("nextPeriodEnd", { required: true })}
                      errors={errors.nextPeriodEnd && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                    />
                  </div>
                  <HeaderSection title={t("Información soporte")} />
                  <div className='flex gap-2'>
                    <InputForm
                      spam={true}
                      label={t("Numero de soporte")}
                      type="text"
                      input="input"
                      cols={1}
                      register={register("supportNumber", { required: true })}
                      errors={errors.supportNumber && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                    />
                    <InputForm
                      spam={true}
                      label={t("Desde")}
                      type="time"
                      input="input"
                      cols={1}
                      register={register("supportFrom", { required: true })}
                      errors={errors.supportFrom && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                    />
                    <InputForm
                      spam={true}
                      label={t("Hasta")}
                      type="time"
                      input="input"
                      cols={1}
                      register={register("supportTo", { required: true })}
                      errors={errors.supportTo && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                    />
                  </div>
                </div>
                <div className="flex flex-col w-full lg:w-1/2 gap-6 justify-center items-center">
                  <ImageUploader
                    image={logo}
                    setImage={setLogo}
                    removeImage={removeLogo}
                    spam
                    label={t("Logo Institución")}
                    register={register}
                    name="logo"
                    setValue={setLogoFile}
                    errors={!logo && !logoFile && <span className="text-red-500 text-xs">{t("required_information")}</span>}
                  />

                  <ImageUploader
                    image={background}
                    setImage={setBackground}
                    removeImage={removeBackground}
                    spam
                    label={t("Fondo de pantalla inicio de sesión institución")}
                    register={register}
                    name="background"
                    setValue={setBackgroundFile}
                    errors={!background && !backgroundFile && <span className="text-red-500 text-xs">{t("required_information")}</span>}
                  />
                </div>
              </div>

              <div className="flex justify-start mt-8 pt-4 border-t border-p-green gap-2">
                <BtnContent type="submit">{t("save_button")}</BtnContent>
                <BtnContent cancel={true} to={`/panel/configurations`}>{t("canceled_button")}</BtnContent>
              </div>
            </form>
          </FormProvider>
        </div>
      )}
    </HomeLayout>

  );
};

export default ConfigurationsForm;
